module.exports = __webpack_public_path__ + "static/media/doc.a9424d03.svg";